import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout'
import Store from '../store'
import { getTemporaryToken } from '@/api/login'

Vue.use(Router)

const constantRoutes = [
    {
        path: '/',
        hidden: true,
        component: () => import('@/views/homeGuide/indexPlus1.vue'),
        // redirect: '/homePage',
        meta: { title: '导览页'}
    },
    {
        path: "/homePage",
        component: Layout,
        redirect: '/homePage',
        meta: { title: '公园主页'},
        children: [
            {
                path: '/homePage',
                name: 'homePage',
                component: () => import('@/views/homePage/index.vue'),
                meta: { title: '公园主页' }
            }
        ]
    },
    {
        path: "/general",
        component: Layout,
        redirect: '/generalIndex',
        meta: { title: '概况' },
        children: [
            {
                path: '/generalIndex',
                name: 'generalIndex',
                component: () => import('@/views/probably/index.vue'),
                meta: { title: '概况' }
            }
        ]
    },
    {
        path: "/zoology",
        component: Layout,
        redirect: '/generalIndex',
        meta: { title: '生态' },
        children: [
            {
                path: '/zoologyIndex',
                name: 'ZoologyIndex',
                component: () => import('@/views/zoology/index.vue'),
                meta: { title: '自然景观' }
            },
            {
                path: '/biologicalAppreciation',
                name: 'BiologicalAppreciation',
                component: () => import('@/views/biologicalAppreciation/index.vue'),
                meta: { title: '生物鉴赏' }
            },
            {
                path: '/biologicalDetail',
                name: 'BiologicalDetail',
                hidden: true,
                component: () => import('@/views/biologicalAppreciation/detail.vue'),
                meta: { title: '详情页' }
            }
        ]
    },
    {
        path: "/humanity",
        component: Layout,
        // redirect: '/humanityIndex',
        meta: { title: '人文' },
        children: [
            {
                path: '/humanityIndex',
                name: 'HumanityIndex',
                component: () => import('@/views/humanity/index.vue'),
                meta: { title: '人文景观' }
            },
            {
                path: '/folkCulture',
                name: 'FolkCulture',
                component: () => import('@/views/folkCulture/index.vue'),
                meta: { title: '民俗文化' }
            }
        ]
    },
    {
        path: "/community",
        component: Layout,
        redirect: '/communityIndex',
        children: [
            {
                path: '/communityIndex',
                name: 'CommunityIndex',
                component: () => import('@/views/community/index.vue'),
                meta: { title: '特色社区' }
            }
        ]
    },
    {
        path: "/popularization",
        component: Layout,
        redirect: '/popularizationIndex',
        children: [
            {
                path: '/popularizationIndex',
                name: 'PopularizationIndex',
                component: () => import('@/views/popularization/index.vue'),
                meta: { title: '科普设施' }
            }
        ]
    },
    {
        path: "/envEducation",
        component: Layout,
        redirect: '/envEducationIndex',
        meta: { title: '环境教育' },
        children: [
            {
                path: '/envEducationIndex',
                name: 'EnvEducationIndex',
                component: () => import('@/views/envEducation/index.vue'),
                meta: { title: '环境教育' }
            },
            {
                path: '/eduDetail',
                name: 'EduDetail',
                hidden: true,
                component: () => import('@/views/envEducation/detail.vue'),
                meta: { title: '详情页' }
            }
        ]
    },
    {
        path: "/media",
        component: Layout,
        // redirect: '/mediaIndex',
        meta: { title: '多媒体' },
        children: [
            {
                path: '/videoIndex',
                name: 'VideoIndex',
                component: () => import('@/views/mediaEducation/index.vue'),
                meta: { title: '视听馆' }
            },
            {
                path: '/videoDetail',
                name: 'VideoDetail',
                hidden: true,
                component: () => import('@/views/mediaEducation/videoPlay.vue'),
                meta: { title: '视听馆详情' }
            },
            {
                path: '/ebookIndex',
                name: 'EbookIndex',
                component: () => import('@/views/ebook/index.vue'),
                meta: { title: '图书馆' },
                // children: [
                   
                // ]
            },
            {
                path: '/ebookDetail',
                name: 'EbookDetail',
                hidden: true,
                component: () => import('@/views/ebook/detail.vue'),
                meta: { title: '图书详情' }
            }
        ]
    },
    {
        path: "/map",
        component: Layout,
        redirect: '/mapIndex',
        meta: { title: '地图' },
        children: [
            {
                path: '/mapIndex',
                name: 'MapIndex',
                component: () => import('@/views/earth/index.vue'),
                meta: { title: '地图' }
            }
        ]
    },
    {
        path: "/login",
        name: "Login",
        component: Layout,
        hidden: true,
        redirect: '/loginIndex',
        children: [
            {
                path: '/loginIndex',
                name: 'LoginIndex',
                component: () => import('@/views/login/index.vue'),
                meta: { title: '登录注册' }
            }
        ]
    },
    {
        path: "/personal",
        name: "Personal",
        component: Layout,
        hidden: true,
        redirect: '/personalIndex',
        children: [
            {
                path: '/personalIndex',
                name: 'PersonalIndex',
                component: () => import('@/views/personal/index.vue'),
                meta: { title: '个人中心' }
            }
        ]
    },
    {
        path: "/newsList",
        name: "NewsList",
        component: Layout,
        hidden: true,
        redirect: '/newsIndex',
        children: [
            {
                path: '/newsIndex',
                name: 'NewsIndex',
                component: () => import('@/views/newsList/index.vue'),
                meta: { title: '公园资讯' }
            },
            {
                path: '/newsIndex/detail',
                name: 'NewsDetail',
                component: () => import('@/views/newsList/detail.vue'),
                meta: { title: '公园资讯-详情' }
            }
        ]
    },
    {
        path: "/search",
        name: "Search",
        component: Layout,
        hidden: true,
        redirect: '/search',
        children: [
            {
                path: '/search',
                name: 'Search',
                component: () => import('@/views/search/index.vue'),
                meta: { title: '搜索' }
            }
        ]
    },
    {
        path: "/collectDetail",
        name: "CollectDetail",
        component: Layout,
        hidden: true,
        redirect: '/collectDetails',
        children: [
            {
                path: '/collectDetails',
                name: 'CollectDetails',
                component: () => import('@/views/collectDetail/index.vue'),
                meta: { title: '查看详情' }
            }
        ]
    },
    {
        path: "/loginWeiChat",
        name: "LoginWeiChat",
        component: () => import('@/views/login/weichatLogin.vue'),
        hidden: true,
        // redirect: '/loginWeichat',
        // children: [
        //     {
        //         path: '/loginWeichat',
        //         name: 'LoginWeichat',
        //         component: () => import('@/views/login/weichatLogin.vue'),
        //         meta: { title: '微信扫码登录' }
        //     }
        // ]
    },
    // ...permissionRoute,
    // 404 page must be placed at the end !!!
    { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () => new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
})
  
const router = createRouter()
  
// resetRouter
// export function resetRouter() {
//     const newRouter = createRouter()
//     router.matcher = newRouter.matcher // reset router
// }
const pathWhite = ['/', '/loginIndex']
router.beforeEach((to, from, next) => {
    if (localStorage.getItem('authorAccessToken')) {
        if (pathWhite.indexOf(to.path) < 0) { // 校验parkId
            if (Store.state.user.activeParkId) {
                next()
            } else{
                next('/')
            }
        } else {
            next()
        }
    } else if (!localStorage.getItem('gustAccessToken')) {
        getTemporaryToken({}).then(res => {
            if (res) {
                Store.dispatch('user/setGustToken', res.data.accessToken)
                localStorage.setItem('gustAccessToken', res.data.accessToken)
                localStorage.setItem('isCustomer', 1)
                if (pathWhite.indexOf(to.path) < 0) { // 校验parkId
                    if (Store.state.user.activeParkId) {
                        next()
                    } else{
                        next('/')
                    }
                } else {
                    next()
                }
            }
        })
    } else {
        if (pathWhite.indexOf(to.path) < 0) { // 校验parkId
            // let token = to.query.token.replace(/%2B/g, '+')
            // window.localStorage.setItem('AUTHTOKEN', JSON.stringify(token))
            // Store.dispatch('setIsIframe', true)
            // console.log(Store.state.user.activeParkId);
            if (Store.state.user.activeParkId) {
                next()
            } else{
                next('/')
            }
        } else {
            next()
        }
    }
})

export default router